import Reveal from "./Reveal.jsx";
import skyline from "../data/skyline.svg";
import burj from "../data/burj.svg";
import heroBg2 from "../data/heroBg.jpeg";

export default function Hero() {
  return (
    <section
      className="hero"
      id="home"
      style={{
        backgroundImage: `
        linear-gradient(
            rgba(11,31,23,.72),
            rgba(11,31,23,.72)
        ),
        url(${heroBg2})
    `,
      }}
    >
      {/* <div className="hero-bokeh" aria-hidden="true">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>
      <div className="hero-decor" aria-hidden="true">
        <span className="blob blob-1"></span>
        <span className="blob blob-2"></span>
        <span className="blob blob-3"></span>

        <span className="gold-ring gold-ring-1"></span>
        <span className="gold-ring gold-ring-2"></span>

        <span className="gold-line gold-line-1"></span>
        <span className="gold-line gold-line-2"></span>
      </div>
      <div className="hero-skyline" aria-hidden="true">
        <img src={skyline} alt="" className="skyline-svg" />
      </div>

      <div className="hero-burj" aria-hidden="true">
        <img src={burj} alt="" className="burj-svg" />
      </div> */}
      <div className="hero-inner container">
        <Reveal as="p" className="eyebrow">
          ✦ We Plan. You Celebrate. We Make It Royale. ✦
        </Reveal>
        <Reveal as="h1" className="hero-title" delay={60}>
          Every Celebration
          <br />
          Deserves a <em>Crown</em>
        </Reveal>
        <Reveal as="p" className="hero-sub" delay={120}>
          Zafwa Royale Events crafts weddings, galas and milestone celebrations
          with regal precision and unforgettable design — from the first sketch
          to the final dance.
        </Reveal>
        <Reveal className="hero-actions" delay={180}>
          <a href="#contact" className="btn btn-gold">
            Start Planning
          </a>
          <a href="#events" className="btn btn-ghost">
            Explore Events
          </a>
        </Reveal>

        <Reveal className="hero-stats" delay={240}>
          <div className="stat">
            <span className="stat-num">160+</span>
            <span className="stat-label">Events Curated</span>
          </div>
          <div className="stat-divider" aria-hidden="true"></div>
          <div className="stat">
            <span className="stat-num">12</span>
            <span className="stat-label">Years of Excellence</span>
          </div>
          <div className="stat-divider" aria-hidden="true"></div>
          <div className="stat">
            <span className="stat-num">45+</span>
            <span className="stat-label">Venues Partnered</span>
          </div>
        </Reveal>
      </div>
      <a href="#about" className="scroll-cue" aria-label="Scroll to content">
        <svg width="16" height="26" viewBox="0 0 16 26">
          <rect
            x="1"
            y="1"
            width="14"
            height="24"
            rx="7"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.2"
          />
          <circle
            className="scroll-dot"
            cx="8"
            cy="8"
            r="2"
            fill="currentColor"
          />
        </svg>
      </a>
    </section>
  );
}
